import { ParamIds, Places } from 'src/Constants'
import BorderoKeys from '../bordero.keys'

export class StatusProcessamentoKeys extends BorderoKeys {
    get place() {
        return Places.mcStatusProcessamentoBordero
    }

    get borderoId() {
        return this._intent.getParameterAsNumber(ParamIds.mcBorderoStatusProcId)
    }

    set borderoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcBorderoStatusProcId, value)
    }
}
